<template>
  <v-card class="pa-2 mb-4">
    <v-card-title class="text-h6 mb-2 mt-2">
      <h4 class="mb-0">
        <strong>Próximo Pedido</strong>
      </h4>
    </v-card-title>
    <v-card-text>
      <div v-if="nextOrder" class="space-y-2">
        <h5 class="font-weight-medium"><strong>{{ nextOrder.mlOrderId }}</strong></h5>
        <div class="text-body-2 text-medium-emphasis">{{ nextOrder.customer }}</div>
        <div class="text-caption text-medium-emphasis">
          {{ getTotalItems(nextOrder) }} items
        </div>
      </div>
      <div v-else class="text-body-2 text-medium-emphasis">
        No hay más pedidos pendientes
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'NextOrder',
  props: {
    nextOrder: {
      type: Object,
      default: null
    }
  },
  methods: {
    getTotalItems(order) {
      return order?.items.reduce((acc, item) => acc + item.picked, 0) || 0
    }
  }
}
</script>

<style scoped>
.space-y-2 > * + * {
  margin-top: 8px;
}
</style>